<template>
    <el-dialog :title="title" :visible="dialogVisible" center width="65%" @close="dialogClose" append-to-body>
        <h4 style="display: flex; justify-content: center; align-items: center;">（数据来源：21世纪教育网）</h4>
        <el-row v-loading="loading" style="display: flex; justify-content: center; align-items: center;">
            <el-col :span="16" :offset="8">
                <el-table :data="count_data" show-summary style="width: 50%" v-loading="loading">
                    <el-table-column prop="xd_name" label="学段"></el-table-column>
                    <el-table-column prop="all_num" label="下载"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <br>
        <el-row v-loading="loading">
            <el-col :span="22" :offset="1">
                <div ref="barChart1" style="width: 100%; height: 300px;"></div>
                <div ref="barChart2" style="width: 100%; height: 300px;"></div>
                <div ref="barChart3" style="width: 100%; height: 300px;"></div>
            </el-col>
        </el-row>
    </el-dialog>
</template>
<script>
import LogService from "~/services/log";
import echarts from 'echarts';
export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        dialogVisible:{
            type: Boolean,
            required: false,
        }
    },
    components:{
    },

    data() {
        return {
            table_list: [],
            count_data: [],
            loading: false,
            color: [
                
            ],
            title: '',
        };
    },

    created() {
        this.getData(this.params);
    },
    
    methods:{
        dialogClose(){
            this.$emit("close");
        },

        getData() {
            this.loading = true;
            LogService.zj_down_log_count_bar(this.params)
            .then(res=>{
                if (res.code == 0 && res.data && res.data.length > 0) {
                    this.count_data = res.data;
                    this.title = this.count_data[0].customer_name;
                    // this.table_list = [this.count_data];
                    this.initChart();
                }else{
                    this.$message({
                        message: '无数据',
                        type: 'error'
                    });
                    this.dialogClose();
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
        initChart() {
            if(!this.count_data || this.count_data.length == 0){
                return false;
            }
            this.count_data.forEach(item => {
                const chartContainer = this.$refs['barChart' + item.xd];
                if (!chartContainer){
                    return false;
                }
                const myChart = echarts.init(chartContainer);
                const options = {
                    title: {
                        text: item.customer_name + '(' + item.xd_name + ')组卷下载情况(' + item.all_num + ')',
                    },
                    // color: this.color,
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        orient: 'horizontal', // 设置图例为水平布局
                        left: 'center', // 将图例居中对齐
                        top: 'top', // 放置在顶部
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: item.subject_names,
                            // axisLabel:{
                            //     interval:0, //控制X轴刻度全部显示
                            //     rotate:45 //倾斜角度
                            // }
                        }
                    ],
                    yAxis: {
                        type: 'value'
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                            mark: {show: true},
                            dataView: {show: true, readOnly: false},
                            magicType: {show: true, type: ['line', 'bar', 'tiled']},
                            restore: {show: true},
                            saveAsImage: {show: true}
                        }
                    },
                    series: [
                        {
                            data: Object.values(item.subject_list),
                            type: 'bar',
                            barWidth: '20%',
                            label: {
                                show: true, // 显示标签
                                position: 'top', // 标签位置（top 表示在柱子顶部）
                                formatter: '{c}', // 显示数据值
                                color: '#000', // 标签颜色
                                fontSize: 12, // 标签字体大小
                            }
                        }
                    ],
                    
                };

                myChart.setOption(options);

                // 监听 dataViewChanged 事件
                myChart.on('dataViewChanged', () => {
                    // 获取更新后的数据
                    const updatedData = myChart.getOption().series[0].data;

                    // 计算 updatedData 的总和
                    const all_num = updatedData.reduce((sum, item) => sum + Number(item.hasOwnProperty('value') ? item.value: item), 0);


                    const targetItem = this.count_data.find(data => data.xd == item.xd);
                    // 获取 targetItem 的索引
                    const index = this.count_data.indexOf(targetItem);


                    // // 更新表格数据
                    this.$set(this.count_data, index, {
                        ...item,
                        all_num: all_num, 
                        subject_list: updatedData.reduce((acc, value, i) => {
                            acc[item.subject_names[i]] = value;
                            return acc;
                        }, {})
                    });

                    // 仅更新标题
                    myChart.setOption({
                        title: {
                            text: item.customer_name + '(' + item.xd_name + ')组卷下载情况(' + all_num + ')',
                        }
                    });

                    // console.log('更新后的表格数据:', this.count_data, updatedData, item.xd, all_num);
                    // 提示用户数据已更新
                    this.$message.success('数据已更新');
                });
            });
            
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/log/dialog/ZjCountBar.vue